import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const s = {
  wrap:   { minHeight: '100vh', background: '#0a0a0f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif' },
  card:   { background: '#16161f', border: '1px solid #1e1e2e', borderRadius: 20, padding: '40px 36px', width: '100%', maxWidth: 440 },
  logo:   { textAlign: 'center', fontSize: 28, marginBottom: 8 },
  title:  { textAlign: 'center', fontSize: 22, fontWeight: 700, color: '#e8e8f0', marginBottom: 6 },
  sub:    { textAlign: 'center', fontSize: 14, color: '#6b6b80', marginBottom: 32 },
  label:  { display: 'block', fontSize: 12, fontWeight: 600, color: '#6b6b80', marginBottom: 6 },
  input:  { width: '100%', background: '#0f0f17', border: '1px solid #1e1e2e', borderRadius: 10, padding: '12px 14px', color: '#e8e8f0', fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 16 },
  btn:    { width: '100%', background: '#6c63ff', color: '#fff', border: 'none', borderRadius: 10, padding: '13px', fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 4 },
  error:  { background: 'rgba(255,101,132,0.1)', border: '1px solid rgba(255,101,132,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#ff6584', marginBottom: 16 },
  success:{ background: 'rgba(85,239,196,0.1)', border: '1px solid rgba(85,239,196,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#55efc4', marginBottom: 16 },
  link:   { color: '#a29bfe', textDecoration: 'none', fontWeight: 600 },
  bottom: { textAlign: 'center', marginTop: 24, fontSize: 13, color: '#6b6b80' },
  note:   { background: 'rgba(108,99,255,0.08)', border: '1px solid rgba(108,99,255,0.2)', borderRadius: 8, padding: '10px 14px', fontSize: 12, color: '#a29bfe', marginBottom: 20, lineHeight: 1.6 },
};

export default function Register() {
  const [form, setForm]       = useState({ name: '', email: '', password: '', confirmPassword: '', phone: '' });
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { register }          = useAuth();
  const navigate              = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');

    if (!form.name || !form.email || !form.password) return setError('সব required field পূরণ করুন');
    if (form.password.length < 6) return setError('Password কমপক্ষে ৬ অক্ষর হতে হবে');
    if (form.password !== form.confirmPassword) return setError('Password match করছে না');

    setLoading(true);
    try {
      await register(form.name, form.email, form.password, form.phone);
      setSuccess('Registration সফল! Client dashboard এ নিয়ে যাচ্ছি...');
      setTimeout(() => navigate('/client'), 1500);
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Registration failed। আবার চেষ্টা করুন।');
      }
    }
    setLoading(false);
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logo}>🤖</div>
        <div style={s.title}>AI Ad Agency</div>
        <div style={s.sub}>নতুন account তৈরি করুন</div>

        <div style={s.note}>
          ℹ️ Registration এর পরে admin আপনার account activate করবে এবং campaign access দেবে।
        </div>

        {error   && <div style={s.error}>{error}</div>}
        {success && <div style={s.success}>{success}</div>}

        <form onSubmit={handleSubmit}>
          <label style={s.label}>আপনার নাম *</label>
          <input style={s.input} name="name" placeholder="পূর্ণ নাম"
            value={form.name} onChange={handleChange} />

          <label style={s.label}>Email *</label>
          <input style={s.input} name="email" type="email" placeholder="you@email.com"
            value={form.email} onChange={handleChange} />

          <label style={s.label}>Phone (WhatsApp)</label>
          <input style={s.input} name="phone" placeholder="01XXXXXXXXX"
            value={form.phone} onChange={handleChange} />

          <label style={s.label}>Password *</label>
          <input style={s.input} name="password" type="password" placeholder="কমপক্ষে ৬ অক্ষর"
            value={form.password} onChange={handleChange} />

          <label style={s.label}>Confirm Password *</label>
          <input style={s.input} name="confirmPassword" type="password" placeholder="আবার লিখুন"
            value={form.confirmPassword} onChange={handleChange} />

          <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'Creating account...' : 'Register করুন'}
          </button>
        </form>

        <div style={s.bottom}>
          Already account আছে? <Link to="/login" style={s.link}>Login করুন</Link>
        </div>
      </div>
    </div>
  );
}
